import { ReactElement } from 'react'
import { CaseIconProps } from './CaseIcon.types'
import AlertIcon from '@assets/images/alert-icon.svg?react'
import IncidentIcon from '@assets/images/incident-icon.svg?react'
import ServiceRequestIcon from '@assets/images/service-request-icon.svg?react'
import './index.scss'

const CASE_TYPE_ICONS: { [key: string]: ReactElement } = {
    incident: <IncidentIcon />,
    alert: <AlertIcon />,
    serviceRequest: <ServiceRequestIcon />,
}

const CaseIcon = ({ caseType }: CaseIconProps) => {
    const icon = CASE_TYPE_ICONS[caseType]

    return <div className="case-icon">{icon}</div>
}

export default CaseIcon
